var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDeleteIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#E13737",
  d: "M13.167 4h4.166v1.666h-1.666v10.833a.833.833 0 0 1-.834.834H3.167a.833.833 0 0 1-.834-.834V5.666H.667V3.999h4.166V1.5a.833.833 0 0 1 .834-.833h6.666a.833.833 0 0 1 .834.833zM14 5.665H4v10h10zM6.5 2.333v1.666h5V2.333z"
})));
export { SvgDeleteIcon as ReactComponent };
export default __webpack_public_path__ + "4fe08e7cae665c5221b99753bf8b93c6.svg";